<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Update Personal Loan Status</h3>

        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="updateStatusForm">
                <b-row>
                    <!-- FIELD STATUS NAME -->
                    <b-col cols="12">
                        <b-form-group label="Status:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'updateStatusName'"
                            >

                            <!-- {{ updatedStatusVal }} -->
                                <b-form-input
                                    v-model="form.status_name"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD STATUS TYPE -->
                    <b-col cols="12">
                        <b-form-group label="Status Type:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'updateStatusType'"
                            >
                                <el-select v-model="form.status_type" placeholder="Select">
                                    <el-option
                                    v-for="item in statusOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD MAIN STATUS -->
                    <b-col cols="12">
                        <b-form-group label="Main Status:" v-if="form.status_type == 'sub'">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'updateStatusMain'"
                            >
                                <el-select v-model="form.main_status" placeholder="Select">
                                    <el-option
                                    v-for="item in filteredStatusMain"
                                    :key="item.status_id"
                                    :label="item.status"
                                    :value="item.status_id"
                                    >
                                    </el-option>
                                </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
											<!-- FIELD TAT DAY -->
											<b-col cols="12" class="mb-0" :class="{'mb-0 d-none':form.tat_stop}">
												<b-form-group label="Tat Days:">
														<b-form-input
																v-model="form.tat_day"
																type="number"
																min=0
																></b-form-input>
												</b-form-group>
										</b-col>
										<b-col cols="12">
											<el-checkbox v-model="form.tat_stop" class="mb-4">Stop TAT Tracking</el-checkbox>
										</b-col>
										<b-col cols="12">
											<el-checkbox v-model="form.is_generate_commission" class="mb-4">Allow Generate Commission</el-checkbox>
										</b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Select, Option, Checkbox } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import mainEventBus from '@/assets/js/mainEventBus.js'

export default {
    props: {
        update_personal_loan_status: Boolean,
        status_data: {
            type: Object
        },
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
    },
    computed: {
        show: {
            get() {
                return this.update_personal_loan_status;
            },
            set(newVal) {
                this.$emit('update:update_personal_loan_status', newVal);
            },
        },
        filteredStatusMain() {
            return this.main_status.filter(item => item.status_id !== this.status_data.status_id)
        }
    },
    data() {
        return {
            statusOptions: [{
                value: 'main',
                label: 'Main Status'
            }, {
                value: 'sub',
                label: 'Sub Status'
            }],
            form: {
                status_id: '',
                status_name: '',
                status_type: '',
                main_status: '',
								tat_day:0,
								tat_stop:0,
								is_generate_commission:0
            }
        }
    },
    async created() {
        this.$watch(
            () => this.status_data,
            (newVal) => {
                if (newVal) {
                    this.form.status_id = newVal.status_id ?? '';
                    this.form.status_name = newVal.status ?? '';
                    this.form.status_type = newVal.group ?? '';
                    this.form.main_status = newVal.parent ? newVal.parent.status : '';
                    this.form.tat_day = newVal.tat_day ?? 0;
                    this.form.tat_stop = (newVal.tat_stop ?? 0) == 1 ? true : false;
                    this.form.is_generate_commission = (newVal.is_generate_commission ?? 0) == 1 ? true : false;
                }
            },
            { immediate: true }
        )

        this.getMainStatus()
    },
    methods:{
        getMainStatus() {
            axios.get(services.lookup + 'personal_loan_status?status_type=main', {headers: getHeader()})
            .then(res => {
                this.main_status = res.data.data
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        submit(){
            const selected = this.main_status.find(item => item.status === this.form.main_status)
            if (selected) {
                this.form.main_status = selected.status_id
            }

            const formData = {
                status: this.form.status_name,
                group: this.form.status_type,
                parent_id: this.form.status_type == "main" ? "" : this.form.main_status,
                tat_day: this.form.tat_day,
                tat_stop: this.form.tat_stop ? 1: 0,
                is_generate_commission: this.form.is_generate_commission ? 1: 0,
            }

            axios.put(services.lookup + 'personal_loan_status/' + this.form.status_id , formData, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                this.$emit('closeModal')
                mainEventBus.$emit('refresh-status')
                this.getMainStatus()
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>